var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b", [_vm._v("Proformas:")]),
      _c("b-table", {
        attrs: {
          small: "",
          fields: _vm.fields,
          items: _vm.filteredSalesOrders,
          responsive: "sm",
        },
        scopedSlots: _vm._u([
          {
            key: "cell(index)",
            fn: function (data) {
              return [_vm._v(" " + _vm._s(data.index + 1) + " ")]
            },
          },
          {
            key: "cell(orderID)",
            fn: function (data) {
              return [
                _c(
                  "b-tooltip",
                  { attrs: { title: "View Proforma", placement: "top" } },
                  [
                    _c(
                      "a",
                      {
                        staticStyle: { cursor: "pointer" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.goToOrderPage(data.item.orderID)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(data.item.orderNumber) + " ")]
                    ),
                  ]
                ),
              ]
            },
          },
          {
            key: "cell(productName)",
            fn: function (data) {
              return [
                _c(
                  "b-tooltip",
                  { attrs: { title: "View Product", placement: "top" } },
                  [
                    _c(
                      "a",
                      {
                        staticStyle: {
                          cursor: "pointer",
                          color: "blue",
                          "text-decoration": "underline",
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.goToProductPage(data.item.productid)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(data.item.productName) + " ")]
                    ),
                  ]
                ),
              ]
            },
          },
          {
            key: "cell(customerName)",
            fn: function (data) {
              return [_vm._v(" " + _vm._s(data.item.customerName) + " ")]
            },
          },
          {
            key: "cell(issuedDate)",
            fn: function (data) {
              return [
                _vm._v(
                  " " + _vm._s(_vm.dayjs(data.value).format("DD/MM/YYYY")) + " "
                ),
              ]
            },
          },
          {
            key: "cell(deliveryDate)",
            fn: function (data) {
              return [
                _vm._v(
                  " " + _vm._s(_vm.dayjs(data.value).format("DD/MM/YYYY")) + " "
                ),
              ]
            },
          },
          {
            key: "cell(Popularity)",
            fn: function (data) {
              return [
                _c("b-progress", {
                  attrs: {
                    value: data.value.value,
                    max: "100",
                    variant: data.value.variant,
                    striped: "",
                  },
                }),
              ]
            },
          },
          {
            key: "cell(order_status)",
            fn: function (data) {
              return [
                _c(
                  "b-badge",
                  { attrs: { pill: "", variant: data.value.variant } },
                  [_vm._v(" " + _vm._s(data.value.status) + " ")]
                ),
              ]
            },
          },
          {
            key: "cell(document)",
            fn: function (data) {
              return [
                _c(
                  "b-button",
                  {
                    staticClass: "mt-0 mt-md-1 mr-2",
                    attrs: { variant: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.handleDocumentBtn(data.item.productid)
                      },
                    },
                  },
                  [_c("span", [_vm._v("View Document")])]
                ),
              ]
            },
          },
          {
            key: "cell(price)",
            fn: function (data) {
              return [_vm._v(" " + _vm._s("$" + data.value) + " ")]
            },
          },
        ]),
      }),
      _c("br"),
      _c("b", [_vm._v("Push Orders:")]),
      _c("b-table", {
        attrs: {
          small: "",
          fields: _vm.fieldsNew,
          items: _vm.pushOrders,
          responsive: "sm",
        },
        scopedSlots: _vm._u([
          {
            key: "cell(index)",
            fn: function (data) {
              return [_vm._v(" " + _vm._s(data.index + 1) + " ")]
            },
          },
          {
            key: "cell(orderID)",
            fn: function (data) {
              return [_vm._v(" " + _vm._s(data.item.orderNumber) + " ")]
            },
          },
          {
            key: "cell(productName)",
            fn: function (data) {
              return [
                _c(
                  "b-tooltip",
                  { attrs: { title: "View Product", placement: "top" } },
                  [
                    _c(
                      "a",
                      {
                        staticStyle: {
                          cursor: "pointer",
                          color: "blue",
                          "text-decoration": "underline",
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.goToProductPage(data.item.productid)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(data.item.productName) + " ")]
                    ),
                  ]
                ),
              ]
            },
          },
          {
            key: "cell(issuedDate)",
            fn: function (data) {
              return [
                _vm._v(
                  " " + _vm._s(_vm.dayjs(data.value).format("DD/MM/YYYY")) + " "
                ),
              ]
            },
          },
          {
            key: "cell(deliveryDate)",
            fn: function (data) {
              return [
                _vm._v(
                  " " + _vm._s(_vm.dayjs(data.value).format("DD/MM/YYYY")) + " "
                ),
              ]
            },
          },
          {
            key: "cell(orderComment)",
            fn: function (data) {
              return [
                !data.item.orderComment
                  ? _c("span", [_vm._v(" - ")])
                  : data.item.orderComment
                  ? _c("span", [
                      _vm._v(" " + _vm._s(data.item.orderComment) + " "),
                    ])
                  : _vm._e(),
              ]
            },
          },
          {
            key: "cell(Popularity)",
            fn: function (data) {
              return [
                _c("b-progress", {
                  attrs: {
                    value: data.value.value,
                    max: "100",
                    variant: data.value.variant,
                    striped: "",
                  },
                }),
              ]
            },
          },
          {
            key: "cell(order_status)",
            fn: function (data) {
              return [
                _c(
                  "b-badge",
                  { attrs: { pill: "", variant: data.value.variant } },
                  [_vm._v(" " + _vm._s(data.value.status) + " ")]
                ),
              ]
            },
          },
          {
            key: "cell(document)",
            fn: function (data) {
              return [
                _c(
                  "b-button",
                  {
                    staticClass: "mt-0 mt-md-1 mr-2",
                    attrs: { variant: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.handleDocumentBtn(data.item.productid)
                      },
                    },
                  },
                  [_c("span", [_vm._v("View Document")])]
                ),
              ]
            },
          },
          {
            key: "cell(price)",
            fn: function (data) {
              return [_vm._v(" " + _vm._s("$" + data.value) + " ")]
            },
          },
        ]),
      }),
      _c(
        "b-modal",
        {
          ref: "modal-view-product-document",
          attrs: {
            id: "modal-view-product-document",
            "ok-only": "",
            "ok-title": "View",
            centered: "",
            size: "lg",
            title: "View Product Documents",
            "hide-footer": true,
          },
        },
        [
          _c("DocumentUpload", {
            attrs: { documentDetails: _vm.documentDetails, viewOnly: true },
            on: { downloadFile: _vm.downloadFile },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }